import {useSetAtom} from "jotai";
import {CallConfirmDialogAtom} from "../pages/project/atoms";

// Same call shape as useConfirm ( confirm({title}) -> Promise<boolean> ) so it's a drop-in
// replacement, but resolves through CallConfirmDialogModal's phone-style UI instead of the
// generic yes/no confirm dialog.
const useCallConfirm = (titleDefault, subtitleDefault) => {
  const setDialog = useSetAtom(CallConfirmDialogAtom);

  const confirm = (props) =>
    new Promise((resolve) => {
      const {title, subtitle} = props || {};
      setDialog({
        open: true,
        title: title || titleDefault || "Start this call?",
        subtitle: subtitle || subtitleDefault || "",
        resolve,
      });
    });

  return confirm;
};

export default useCallConfirm;
